<template>

  <header v-bind:class="$route.name === 'portfolio-detail' ?  'header header--is-single' : 'header'">
    <router-link to="/" class="header__logo" id="jsLogo">
      <span>Claudia De Medio</span>
    </router-link>
    <nav class="header__nav">
      <router-link to="/">Portfolio</router-link>
      <router-link to="/resume">Resume</router-link>
      <router-link to="/contacts">Contacts</router-link>
    </nav>
    <div class="header__hamburger" @click="toggleHamburger()" id="jsHambuger">
      <div class="header__hamburger__line"></div>
      <div class="header__hamburger__line"></div>
      <div class="header__hamburger__line"></div>
    </div>
    <div class="header__mobile" id="jsMobileNav">
      <div class="header__mobile__name">Claudia De Medio</div>
      <div class="header__mobile__nav">
        <router-link to="/portfolio">Portfolio</router-link>
        <router-link to="/resume">Resume</router-link>
      </div>
      <div class="header__mobile__contacts">
        <div class="header__mobile__contacts__label">Contacts</div>
        <a class="header__mobile__contacts__email" href="mailto:claudiademedio@gmail.com">claudiademedio@gmail.com</a>
        <div class="header__mobile__contacts__telephone">+34 696 344 016</div>
        <div class="header__mobile__contacts__social">
          <a href="https://it.linkedin.com/in/claudia-de-medio-69745964" class="header__mobile__contacts__social__icon header__mobile__contacts__social__icon--linkedin"></a>
          <a href="https://www.pinterest.it/claudiademedio/" class="header__mobile__contacts__social__icon header__mobile__contacts__social__icon--pinterest"></a>
          <a href="https://www.behance.net/ClaudiaDeMedio" class="header__mobile__contacts__social__icon header__mobile__contacts__social__icon--behance"></a>
        </div>
        <div class="header__mobile__contacts__made">
          Code with ❤️ and 🔥 by me
        </div>
      </div>
    </div>
  </header>

  

</template>

<script>

  export default {
    name: 'Header',
    data: function() {
      return {
        mobile: false,
        hamburgerOpen: true
      }
    },
    methods: {
      checkMediaQuery() {
        if(window.matchMedia("(max-width: 767px)").matches) {
          this.mobile = true
        } else {
          this.mobile = false
          this.closeHamburger();
        }
      },
      toggleHamburger() {
        this.hamburgerOpen = !this.hamburgerOpen
        this.checkHamburgeClass()
      },
      openHamburger() {
        document.getElementById('jsLogo').classList.add("is-open")
        document.getElementById('jsHambuger').classList.add("is-open")
        document.getElementById('jsMobileNav').classList.add("is-open")
      },
      closeHamburger() {
        document.getElementById('jsLogo').classList.remove("is-open")
        document.getElementById('jsHambuger').classList.remove("is-open")
        document.getElementById('jsMobileNav').classList.remove("is-open") 
      },
      checkHamburgeClass() {
        if(this.hamburgerOpen == true && this.mobile == true) {
          this.openHamburger();
        } else {
          this.closeHamburger();
        }
      }
    },
    // use mounted for script always running in components
    mounted() {
      window.onload = () => {
        this.checkMediaQuery()
      }
      window.onresize = () => {
        this.checkMediaQuery()
      }
    },
    watch: {
    $route() {
      this.hamburgerOpen = false
      this.checkHamburgeClass()
    }}
  }

</script>

<style scoped lang="scss">

  @import '@/scss/app.scss';

  .header {
    @include container;
    padding: 50px 0;

    @include mq(small) {
      background-color: $lighter;
      height: 80px;
      left: 0;
      padding: 0;
      position: fixed;
      right: 0;
      top: 0;
      z-index: 100;
      max-width: 100%;
    }
  }

  .header__logo {
    width: 40px;
    height: 40px;
    background-color: $dark;
    border-radius: 50%;
    display: block;
    position: absolute;
    top: 45px;
    left: 0;
    transition: all ease-in-out .2s;
    text-decoration: none;

    @include mq(small) {
      left: 20px;
      top: 20px;
    }
    
    span {

      @keyframes showName {
        0% {
          opacity: 0;
          left: 45px;
        }

        100% {
          opacity: 1;
          left: 55px;
        }
      }

      @keyframes removeName {
        100% {
          opacity: 0;
          left: 45px;
        }

        0% {
          opacity: 1;
          left: 55px;
        }
      }

      @include ui;
      animation: removeName .3s 1 forwards;
      left: 45px;
      opacity: 0;
      position: absolute;
      top: 5px;
      width: 135px;

      .header--is-single & {
        animation: showName .3s 1 forwards;
      }
    }

    &.is-open {
      transform: scale(50); 

      span {
        display: none;
      }
    }
  }

  .header__nav {
    text-align: center;
    flex: 1;

    @include mq(small) {
      display: none;
    }
  }

  .header__nav a {
    @include ui;
    margin-right: 16px;
    padding: 0 3px;
    text-decoration: none;

    &:last-child {
      margin-right: 0;
    }

    &.router-link-exact-active {
      background-color: $dark;
      color: $white;
    }
  }

  .header__hamburger {
    height: 60px;
    position: absolute;
    right: 5px;
    top: 10px;
    width: 60px;
    padding: 20px 15px;
    z-index: 1;
    display: none;

    @include mq(small) {
      display: block
    }
  }

  .header__hamburger__line {
    background-color: $dark;
    height: 2px;
    position: absolute;
    width: 30px;
    transition: all ease-in-out .2s; 

    &:nth-child(1) {
      top: 20px;
    }

    &:nth-child(2) {
      top: 29px;
    }

    &:nth-child(3) {
      top: 38px;
    }

    .header__hamburger.is-open & {
      background-color: $lighter;
      width: 25px;

      &:nth-child(1) {
        top: 29px;
        transform: rotate(-45deg);
      }

      &:nth-child(2) {
        opacity: 0;
        transform: scaleX(0);
      }

      &:nth-child(3) {
        top: 29px;
        transform: rotate(-135deg);
      }
    }
  }

  .header__mobile {
    background-color: $dark;
    bottom: 0;
    left: 0;
    padding: 25px 30px;
    position: fixed;
    right: 0;
    top: 0px;
    opacity: 0;
    visibility: hidden;
    transition: all ease-in-out .2s;
    display: none;

    @include mq(small) {
      display: block;
    }

    &.is-open {
      opacity: 1;
      visibility: visible;
    }
  }

  .header__mobile__name {
    @include title(small);
    font-size: 20px;
    color: $lighter;
    margin-bottom: 60px;
  }

  .header__mobile__nav {
    margin-bottom: 30px;
  }

  .header__mobile__nav a {
    @include title(small);
    background-color: $lighter;
    display: block;
    height: 60px;
    margin-bottom: 30px;
    line-height: 60px;
    padding: 0 20px;
    text-decoration: none;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      width: 60px;
      height: 60px;
      top: 0;
      right: 0;
      background: url('../assets/arrow--dark.svg') 50% 50% no-repeat;
      transform: rotate(-90deg);
    }

    &:last-child {
      margin-bottom: 0;
    }

    &.router-link-exact-active {
      background-color: $dark;
      border: 1px solid $white;
      color: $white;

      &:after {
        background: url('../assets/yep.svg') 50% 50% no-repeat;
        transform: rotate(0deg);
      }
    }
  }

  .header__mobile__contacts {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
  }

  .header__mobile__contacts__label {
    @include ui(back);
    color: $dark;
    background-color: $lighter;
    margin-bottom: 20px;
  }

  .header__mobile__contacts__email {
    @include ui(big);
    color: $lighter;
    text-decoration: none;
  }

  .header__mobile__contacts__telephone {
    @include ui(big);
    color: $lighter;
    margin-bottom: 20px;
    text-decoration: none;
  }

  .header__mobile__contacts__social {
    display: flex;
    justify-content: flex-start;
  }

  .header__mobile__contacts__social__icon {
    display: block;
    width: 20px;
    height: 20px;
    margin-right: 30px;

    &.header__mobile__contacts__social__icon--linkedin {
      background: url('../assets/icon-linkedin.svg') 50% 50% no-repeat;
    }

    &.header__mobile__contacts__social__icon--pinterest {
      background: url('../assets/icon-pinterest.svg') 50% 50% no-repeat;
    }

    &.header__mobile__contacts__social__icon--behance {
      background: url('../assets/icon-behance.svg') 50% 50% no-repeat;
    }
  }

  .header__mobile__contacts__made {
    color: $white;
    padding-top: 45px;

    span {
      color: $dark;
    }
  }

</style>
